const styles = () => ({
    detailsWrapper: {
        backgroundColor: '#d8e0e5',
        borderRadius: 6,
        minHeight: 65,
        alignItems: 'center',
    },
    detailTitle: {
        fontSize: '0.8125rem',
        fontWeight: 800,
    },
    detailContent: {
        fontSize: '1.0625rem',
    },
    list: {
        fontWeight: 700,
        marginBottom: 0,
    },
    listItem: {
        fontSize: '1rem',
        fontWeight: 'inherit',
    },
});

export default styles;
